import React from 'react';
import Modal from 'react-modal';
import { translate } from '../../Services/translation';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: 'fit-content',
    height: 'fit-content',
    borderRadius: '20px',
  },
};

export const BCConfirmationModal = ({
  isOpen,
  onRequestClose,
  title,
  text,
  onConfirm,
}) => {
  return (
    <Modal
      ariaHideApp={false}
      preventScroll={false}
      isOpen={isOpen}
      onRequestClose={() => onRequestClose()}
      style={customStyles}
      shouldCloseOnOverlayClick={false}
    >
      <h3>{title}</h3>
      <p>{text}</p>
      <div className="BCConfirmModal__buttons">
        <button
          className="BCConfirmModal__buttons__button"
          onClick={() => onRequestClose()}
        >
          {translate('business.modal.cancel')}
        </button>
        <button
          className="BCConfirmModal__buttons__button"
          onClick={() => onConfirm()}
        >
          {translate('business.modal.confirm')}
        </button>
      </div>
    </Modal>
  );
};
